<template>
  <div class="home-container">
    <div class="home-content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="选择分类" prop="orderWorkCategoryId">
          <el-cascader
            :props="props"
            v-model="ruleForm.orderWorkCategoryId"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="描述图片" prop="img">
          <upload
            :url.sync="ruleForm.img"
            :src="ruleForm.img"
            type="img"
          ></upload>
          <div style="color: red">*建议图片上传尺寸（50 * 50）</div>
        </el-form-item>
        <el-form-item label="地址" prop="address" style="width: 80%">
          <el-input
            v-model="ruleForm.address"
            placeholder="请输入地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="详细描述" prop="des">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="请输入详细描述"
            v-model="ruleForm.des"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="报事时间"
          label-width="100px"
          prop="distributeTime"
        >
          <el-date-picker
            v-model="ruleForm.distributeTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="选择分发人" prop="manageUserId">
          <el-select
            clearable filterable
            v-model="ruleForm.manageUserId"
            placeholder="请选择物业人员"
          >
            <el-option
              :label="item.userName"
              :value="item.id"
              v-for="(item, ind) in personList"
              :key="ind"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload/index.vue";
export default {
  components: {
    upload,
  },
  data() {
    return {
      ruleForm: {
        orderWorkCategoryId: "",
        manageUserId: "",
        img: "",
        address: "",
        des: "",
        distributeTime:""
      },
      options: [],
      props: {
        value: "id",
        label: "name",
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          let page = {
            current: 1,
            size: 100,
            type: 1,
            parentId: level == 1 ? data.id : "",
          };
          this.$Apis.orderWorkCategoryList(page).then((res) => {
            if (res.code == 200) {
              const nodes = Array.from(res.data.list).map((item, ind) => ({
                id: item.id,
                name: item.name,
                leaf: level >= 1,
              }));
              // 通过调用resolve将子节点数据返回，通知组件数据加载完成
              resolve(nodes);
            }
          });
        },
      },
      personList: [],
      rules: {
        orderWorkCategoryId: [
          { required: true, message: "请选择分类", trigger: "blur" },
        ],
        // img: [{ required: true, message: "请上传图片", trigger: "blur" }],
        address: [{ required: true, message: "请填写地址", trigger: "blur" }],
        des: [{ required: true, message: "请输入描述", trigger: "blur" }],
        manageUserId: [
          { required: true, message: "请选择分发人", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = {
            des: this.ruleForm.des || "",
            address: this.ruleForm.address,
            img: this.ruleForm.img || "",
            manageUserId: this.ruleForm.manageUserId,
            orderWorkCategoryId: this.ruleForm.orderWorkCategoryId.pop(),
            distributeTime: this.ruleForm.distributeTime,
            type: 1,
          };
          this.btnLoading = true;
          this.$Apis.orderWorkAdd(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$refs[formName].resetFields();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    onLoad() {
      this.$Apis.manageTotalList().then((res) => {
        if (res.code == 200) {
          let list = res.data.filter((item) => item.userType == 1);
          this.personList = list;
        }
      });
      // let page = {
      //   current: 1,
      //   size: 100,
      //   type: 2,
      // };
      // this.$Apis.orderWorkCategoryList(page).then((res) => {
      //   if (res.code == 200) {
      //     this.options = res.data.list;
      //   }
      // });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style>
</style>